/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureUsageDto
 */
export interface FeatureUsageDto {
    /**
     * Number of users using this feature
     * @type {number}
     * @memberof FeatureUsageDto
     */
    usersCount: number;
    /**
     * Percentage of total users
     * @type {number}
     * @memberof FeatureUsageDto
     */
    percentage: number;
}

export function FeatureUsageDtoFromJSON(json: any): FeatureUsageDto {
    return FeatureUsageDtoFromJSONTyped(json, false);
}

export function FeatureUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usersCount': json['usersCount'],
        'percentage': json['percentage'],
    };
}

export function FeatureUsageDtoToJSON(value?: FeatureUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usersCount': value.usersCount,
        'percentage': value.percentage,
    };
}

